import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddKeywordsCopy({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Add Keywords - Copy and Paste'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

